export const getScalingFactor = (lat) => {
  const earthRadius = 6371;

  const latRadians = lat * Math.PI / 180;

  const scaleFactor = earthRadius * Math.cos(latRadians);

  return scaleFactor / 1000;
};